import {type} from 'arktype';
import {NonNegativeDoubleString} from './shared';

// prettier-ignore
export const OperationsSettings = type({
    eur_top_up_card_minimal: NonNegativeDoubleString,
    eur_top_up_card_maximal_per_operation: NonNegativeDoubleString,
    eur_top_up_card_maximal_per_day_current: NonNegativeDoubleString,
    eur_top_up_card_maximal_per_month_current: NonNegativeDoubleString,
    eur_top_up_card_maximal_per_day_total: NonNegativeDoubleString,
    eur_top_up_card_maximal_per_month_total: NonNegativeDoubleString,
    eur_top_up_card_fee_relative: NonNegativeDoubleString,
    eur_top_up_card_fee_absolute: NonNegativeDoubleString,
    eur_exchange_usd_minimal: NonNegativeDoubleString,
    eur_exchange_usd_rate: NonNegativeDoubleString,
    usd_top_up_card_minimal: NonNegativeDoubleString,
    usd_top_up_card_maximal_per_operation: NonNegativeDoubleString,
    usd_top_up_card_maximal_per_day_current: NonNegativeDoubleString,
    usd_top_up_card_maximal_per_month_current: NonNegativeDoubleString,
    usd_top_up_card_maximal_per_day_total: NonNegativeDoubleString,
    usd_top_up_card_maximal_per_month_total: NonNegativeDoubleString,
    usd_top_up_card_fee_relative: NonNegativeDoubleString,
    usd_top_up_card_fee_absolute: NonNegativeDoubleString,
    usd_exchange_eur_minimal: NonNegativeDoubleString,
    usd_exchange_eur_rate: NonNegativeDoubleString,
    buy_fee_btc_absolute: NonNegativeDoubleString,
    buy_fee_eth_absolute: NonNegativeDoubleString,
    buy_fee_erc20_absolute: NonNegativeDoubleString,
    exchange_crypto_relative: NonNegativeDoubleString,
    exchange_stablecoin_relative: NonNegativeDoubleString,
    cards_disabled: 'boolean',
    banks_disabled: 'boolean',
    exchange_disabled: 'boolean',
});
export type OperationsSettings = typeof OperationsSettings.infer;
